import script from "./SongReg3.vue?vue&type=script&setup=true&lang=js"
export * from "./SongReg3.vue?vue&type=script&setup=true&lang=js"

import "./SongReg3.vue?vue&type=style&index=0&id=60b7e1cb&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b7e1cb"]])

export default __exports__